import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IAccount, IFinStatements } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs';
import { FcpTreeItem } from '../../domain/models/fcpTreeItem.model';
import { toggleActiveTestItem } from '../../domain/reducers/fcp.actions';
import { selectActiveTestItem } from '../../domain/reducers/fcp.reducer';
import { FcpTreeElement } from './fcpTreeElement.directive';

@UntilDestroy()
@Component({
    selector: 'app-fcp-test-item',
    templateUrl: 'fcpTestItem.component.html',
    styleUrls: ['fcpTestItem.component.scss'],
})
export class FcpTestItemComponent extends FcpTreeElement implements OnInit, OnChanges {
    override protectClosingAndOpeningValues = true;
    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes['outputFinStatements']) {
            if (this.item) {
                this.item.adjustedValue = this.findAdjustedValue(this.item.uid, this.outputFinStatements);
            }
        }
    }

    protected override filterMethod(item: FcpTreeItem): boolean {
        return false;
    }

    private findAdjustedValue(uid: string, outputFinStatements: IFinStatements[]): number {
        for (const finStatement of outputFinStatements) {
            const foundAccount =
                this.searchInAccounts(finStatement.templateAndAccountsMapping.accounts, uid) ||
                this.searchInAccounts(finStatement.templateAndAccountsMapping.balanceSwitchAccounts, uid);

            if (foundAccount) {
                return foundAccount.calculatedClosingBalance;
            }
        }
        return 0; // Return null or a default value if not found
    }
    private searchInAccounts(accounts: IAccount[], uid: string): IAccount | null {
        if (!accounts) return null;
        return accounts.find((account) => account.type + account.accountNumber + account.name === uid) || null;
    }

    override calculateAdjustedValues(): number {
        const accountVal = this.findAdjustedValue(this.item.uid, this.outputFinStatements);
        return accountVal;
    }
    ngOnInit() {
        this.active$ = this.store.select(selectActiveTestItem).pipe(
            map((storeItem: FcpTreeItem) => {
                if (storeItem && storeItem.name === this.item.name) {
                    return true;
                } else {
                    return false;
                }
            }),
            untilDestroyed(this),
        );
    }

    toggleActivate() {
        this.store.dispatch(toggleActiveTestItem({ payload: this.item }));
    }
}
